<template>
  <v-card>
    <v-card-text class="pb-2">
      <v-row no-gutters>
        <v-col style="width: 80px; max-width: 80px; min-width: 80px;" class="mt-n7">
          <v-card 
            :class="cardColor" 
            class="white--text elevation-5" 
            style="padding-bottom: 100%; position: relative;"
          >
            <v-icon
              class="white--text"
              x-large
              style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)"
              v-html="icons[ type ]"
            >
            </v-icon>
          </v-card>
        </v-col>
        <v-col>
          <div class="text-right subtitle-2 grey--text text--lighten-1 mt-n3">{{ label }}</div>
          <div v-if="loading">
            <v-skeleton-loader
              ref="skeleton"
              type="heading"
              class="ml-auto"
            ></v-skeleton-loader>
          </div>
          <div v-else class="text-right" style="font-size: 2em; line-height: 1.5em;">
            <div v-if="isRate">{{ value }} %</div>
            <div v-else>{{ value | currencyRounded }}</div>
          </div>
        </v-col>
        
        <v-col cols="12" class="mt-4" v-if="loading">
          <v-divider />
          <v-row no-gutters>
            <v-col>
              <v-skeleton-loader
                ref="skeleton"
                type="text"
                class="mx-auto mt-1"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-else-if="type == 'win'" cols="12" class="mt-4">
          <v-divider />
          <v-row no-gutters>
            <v-col class="text-left grey--text">
              <v-icon x-small class="grey--text" v-html="icons.loss"></v-icon>
              Losses
            </v-col>
            <v-col class="text-right grey--text">
              {{ footer1 | currencyRounded }}
            </v-col>
          </v-row>
        </v-col>
        <v-col v-else-if="type == 'win_rate'" cols="12" class="mt-4">
          <v-divider />
          <v-row no-gutters>
            <v-col class="text-left primary--text">
              <v-icon x-small class="primary--text" v-html="icons.win"></v-icon>
              {{ footer1 | numberRounded }}
            </v-col>
            <v-col class="text-right error--text">
              <v-icon x-small class="error--text" v-html="icons.loss"></v-icon>
              {{ footer2 | numberRounded }}
            </v-col>
          </v-row>
        </v-col>
        <v-col v-else-if="type == 'conversion_rate'" cols="12" class="mt-4">
          <v-divider />
          <v-row no-gutters>
            <v-col class="text-left accent--text">
              <v-icon x-small class="accent--text" v-html="icons.opportunity"></v-icon>
              {{ footer1 | currencyRounded }}
            </v-col>
            <v-col class="text-right primary--text">
              <v-icon x-small class="primary--text" v-html="icons.win"></v-icon>
              {{ footer2 | currencyRounded }}
            </v-col>
          </v-row>
        </v-col>
        <v-col v-else cols="12" class="mt-4 text-center">
          <v-divider />
          <div class="caption grey--text">{{ quantity }} Total<!-- - View--></div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>

export default {
  name: 'AmountWidget',
  props: {
    type: {
      type: String,
      default: 'opportunity'
    },
    value: {
      type: [String, Number],
      default: 0
    },
    footer1: {
      type: [String, Number],
      default: ''
    },
    footer2: {
      type: [String, Number],
      default: ''
    },
    quantity: {
      type: [String, Number],
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  computed: {
    icons () {
      return {
        opportunity: 'mdi-account-cash',
        win: 'mdi-trophy',
        loss: 'mdi-thumb-down',
        pending: 'mdi-clock-outline',
        followup: 'mdi-phone',
        win_rate: 'mdi-party-popper',
        conversion_rate: 'mdi-account-convert'
      }
    },
    cardColor () {
      switch(this.type) {
        case 'opportunity': 
          return 'accent'
        case 'pending': 
          return 'secondary'
        case 'followup': 
          return 'warning'
        case 'win':
          return 'primary'
        case 'conversion_rate':
        case 'win_rate':
          return 'secondary'
        default:
          return ''
      }
    },
    label () {
      switch(this.type) {
        case 'opportunity': 
          return 'Opportunit' + (this.quantity == 1 ? 'y' : 'ies')
        case 'pending': 
          return 'Pending'
        case 'followup': 
          return 'Follow Up' + (this.quantity == 1 ? '' : 's')
        case 'win':
          return 'Win' + (this.quantity == 1 ? '' : 's')
        case 'conversion_rate': 
          return 'Conversion Rate'
        case 'win_rate':
          return 'Win Rate'
        default: 
          return ''
      }
    },
    isRate () {
      if(this.type == 'conversion_rate' || this.type == 'win_rate') return true
      return false
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  .v-skeleton-loader.ml-auto ::v-deep .v-skeleton-loader__heading {
    margin-left: auto;
  }
</style>